import type { MergedRecommendPrice, RecommendPrice } from '@/lib/service/types';

export function handleMergePricesData(prices: RecommendPrice[]): MergedRecommendPrice[] {
  const mergedPrices: MergedRecommendPrice[] = [];

  for (const price of prices) {
    const foundMergedPrice = mergedPrices.find((item) => item.title === price.title);

    if (!foundMergedPrice) {
      mergedPrices.push({
        title: price.title,
        description: price.description,
        items: [
          {
            category1: price.category1,
            category2: [price.category2],
            price: [{ amount: price.price, currency: price.currency }],
          },
        ],
      });
      continue;
    }

    const foundMergedPriceItem = foundMergedPrice.items.find(
      (item) => item.category1 === price.category1
    );

    if (!foundMergedPriceItem) {
      foundMergedPrice.items.push({
        category1: price.category1,
        category2: [price.category2],
        price: [{ amount: price.price, currency: price.currency }],
      });
      continue;
    }

    // Legacy Breitling parity: ECS never sends the same category2 twice per category1.
    // Duplicate rows are ignored rather than merged or overwritten.
    if (!foundMergedPriceItem.category2.includes(price.category2)) {
      foundMergedPriceItem.category2.push(price.category2);
      foundMergedPriceItem.price.push({ amount: price.price, currency: price.currency });
    }
  }

  return mergedPrices;
}
